const EFFECT_UI_TEXT_MAP: Record<string, string> = {
  'Reset to defaults': '恢复默认',
  'Disable effect': '禁用特效',
  'Enable effect': '启用特效',
  'Remove effect': '删除特效',
  On: '开',
  Off: '关',
  Channel: '通道',
  'Reset Channel': '重置通道',
  Master: '主通道',
  Red: '红',
  Green: '绿',
  Blue: '蓝',
  Shadows: '阴影',
  Midtones: '中间调',
  Highlights: '高光',
  Brightness: '亮度',
  Contrast: '对比度',
  Exposure: '曝光',
  'Exposure (EV)': '曝光（EV）',
  Offset: '偏移',
  Gamma: '伽马',
  'Hue Shift': '色相偏移',
  Invert: '反相',
  Levels: '色阶',
  Saturation: '饱和度',
  Temperature: '色温',
  Tint: '色调',
  Grayscale: '灰度',
  Sepia: '褐色',
  Curves: '曲线',
  'Color Wheels': '色轮',
  Vibrance: '自然饱和度',
  Vignette: '暗角',
  'Film Grain': '胶片颗粒',
  Sharpen: '锐化',
  Posterize: '色调分离',
  Glow: '辉光',
  'Edge Detect': '边缘检测',
  Scanlines: '扫描线',
  'Color Glitch': '彩色故障',
  Halftone: '半调网点',
  Dither: '抖动',
  ASCII: 'ASCII 字符画',
  Threshold: '阈值',
  Pixelate: '像素化',
  'RGB Split': 'RGB 分离',
  Twirl: '旋扭',
  Wave: '波浪',
  'Bulge/Pinch': '膨胀/挤压',
  Kaleidoscope: '万花筒',
  Mirror: '镜像',
  'Fluted Glass': '条纹玻璃',
  'Gaussian Blur': '高斯模糊',
  'Box Blur': '方框模糊',
  'Motion Blur': '运动模糊',
  'Radial Blur': '径向模糊',
  'Zoom Blur': '缩放模糊',
  'Chroma Key': '色度抠像',
  Amount: '强度',
  Size: '大小',
  Radius: '半径',
  Softness: '柔化',
  Roundness: '圆度',
  Angle: '角度',
  Samples: '采样数',
  'Center X': '中心 X',
  'Center Y': '中心 Y',
  Shape: '形状',
  Lines: '直线',
  'Irregular Lines': '不规则线条',
  Zigzag: '锯齿',
  Pattern: '图案',
  'Key Color': '抠像颜色',
  'Green Screen': '绿幕',
  'Blue Screen': '蓝幕',
  Tolerance: '容差',
  'Edge Softness': '边缘柔化',
  'Spill Suppression': '溢色抑制',
  'Original Opacity': '原始透明度',
  'Grain Mixer': '颗粒混合',
  'Grain Overlay': '颗粒叠加',
}

export function translateEffectUiText(text: string): string {
  return EFFECT_UI_TEXT_MAP[text] ?? text
}
